export const check = () => (
  <>
    <path
      d="M4 14.7642L10.655 20.8648L24 7"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </>
)
